import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ModulosARK } from '../../../services/autenticacion.service';

@Component({
  selector: 'app-usuarios-permisos',
  templateUrl: './usuarios-permisos.component.html',
  styleUrls: ['./usuarios-permisos.component.scss']
})
export class UsuariosPermisosComponent implements OnInit {

  @Input() public permiso: any;
  @Output() lecturaClick = new EventEmitter<any>();
  @Output() escrituraClick = new EventEmitter<any>();
  private permisosConSoloLectura = [];

  constructor() { }

  public permiteEscritura: boolean = true;

  ngOnInit() {
    this.permisosConSoloLectura = [ ModulosARK.CatalogoReportes ];
    this.format();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.format();
  }

  assignPermisoLectura(status) {
    status = (status == true)? 1 : 0;
    this.permiso.lectura = status;
    if (this.permiso.lectura != 1) {
      this.permiso.escritura = 0;
    }
    this.lecturaClick.emit(this.permiso);
  }

  assignPermisoEscritura(status) {
    status = (status == true)? 1 : 0;
    // No se muestra para el permiso de eliminar contratos y autorizar cuentas por pagar (ya que solo se requiere el permiso de editar)
    if (this.permiso.idPermisos == 13 || this.permiso.idPermisos == 20){
      this.permiso.escritura = status;
    }else{
      if (this.permiso.lectura == 1) {
        this.permiso.escritura = status;
      } else {
        this.permiso.escritura = 0;
      }
    }
    this.escrituraClick.emit(this.permiso);
  }

  getSwitcherElement(type) {
    return 'permiso_' + this.permiso.idPermisos + '_' + type; 
  }

  format() {
    if (this.permiso.lectura == true) {
      this.permiso.lectura = 1;
    } 
    if (this.permiso.lectura == false) {
      this.permiso.lectura = 0;
    }
    if (this.permiso.escritura == true) {
      this.permiso.escritura = 1;
    } 
    if (this.permiso.escritura == false) {
      this.permiso.escritura = 0;
    }

    if(this.permisosConSoloLectura.includes(this.permiso.idPermisos)){
      this.permiteEscritura = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/usuarios/usuarios-permisos/usuarios-permisos.component.ts